export default {
  lista: [],
  mapper: {}, // {subclass: class}
  data_atualizacao: null,
  loading: false,
}
